import { render, staticRenderFns } from "./MyPayments.vue?vue&type=template&id=56e30a1e&"
import script from "./MyPayments.vue?vue&type=script&lang=js&"
export * from "./MyPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports